import { useLanguage, useTheme } from '../providers/preferenceProvider';
import logo from '../media/logo.svg';
import logo_white from '../media/logo_white.svg';
import BookingsList from '../shared/booking/bookingsList'
import { Link } from 'react-router-dom';
import '../css/home.css';
import { useCallback, useEffect, useState } from 'react';
import { getUserBookings } from '../api/booking-api';
import { getRooms } from '../api/room-api';
import { useConfig } from '../providers/configProvider';
import Overlay from '../shared/overlays/editBooking';

const Home = () => {
  const { t } = useLanguage();
  const { theme } = useTheme();
  const [bookings, setBookings] = useState([]);
  const [rooms, setRooms] = useState([]);
  const [selectedBooking, setSelectedBooking] = useState({});
  const [showOverlay, setShowOverlay] = useState(false);
  const { config } = useConfig();
  const logoSrc = theme === 'dark' ? logo_white : logo;

  const fetchData = useCallback( async (filters = undefined, refresh = false) => {
    const queryParams = new URLSearchParams();
    queryParams.append('sortBy', 'startTime:ASC');
    queryParams.append('onlyUpcoming', 'true');
    queryParams.append('search', '');
    queryParams.append('pageSize', 4);
    queryParams.append('page', 1);

    try {
      const [response, rooms] = await Promise.all([
        getUserBookings(config.user.id, queryParams),
        getRooms() 
      ])

      if (response.data.rows) {
        const localBookings = refresh ? [] : [...bookings];
        const newBookings = response.data.rows.map((booking) => ({
          ...booking,
          "Room": rooms.data.find((room) => room.id === booking.roomId),
        }));
        setBookings([...localBookings, ...newBookings]);
        setRooms(rooms.data);
      }
    } catch (error) {
      console.error('Error fetching bookings:', error);
    }    
  });

  useEffect(() => {
    fetchData();
  }, []);

  function openOverlay(booking) {
    booking.startTime = new Date(booking.startTime);
    booking.endTime = new Date(booking.endTime);
    setSelectedBooking(booking);
    setShowOverlay(true);
  }

  function closeOverlay() {
    setShowOverlay(false);
    fetchData(undefined, true);
  }

  function getSelectedBookingWithCost() {
    const cost = getCost(selectedBooking);
    return {
      ...selectedBooking,
      ...(cost ? { credits: getCost(selectedBooking) } : {})
    };
  }

  function getCost(booking){
    if (rooms?.length > 0 && booking?.roomId) {
      const room = rooms.find(room => room.id === booking.roomId);
      const endTime = new Date(booking.endTime);
      const startTime = new Date(booking.startTime);
      const creditsPerMin = room.credits / room.interval;
      const bookingDurationInMins = Math.round(((endTime.getTime() - startTime.getTime()) / (1000 * 60)));
      return +(creditsPerMin * bookingDurationInMins).toFixed(2);
    }
  }

  return (
    <>
      <main className="main-container">
        <div className="home-main-container">
          <div className="home-box-top">
            <div className="main-header">{t.home}</div>
            <div className="content-container">
              <div className="welcome-person-text"> {t.welcome} {config.user.firstname}</div>
              <div className="workplace-logo">
                <img src={logoSrc} alt="42Workspace" />
              </div>
              <Link to="/book"><button className="home-page-button mt-2 mb-2" >{t.make_booking}</button></Link>
            </div>
          </div>
          <div className="home-box-bottom gap-2">
            <div className="main-header">{t.upcoming_bookings}</div>
            {bookings.length > 0 ? (
              <>
                <BookingsList bookingsList={bookings} onBookingClick={openOverlay} refreshBookings={() => fetchData(undefined, true)}/>
                <div className="bookings-list-footer mb-2">
                  <button className="home-page-button">
                    <Link to="/bookings">{t.all_bookings}</Link>
                  </button>
                </div>
              </>
            ) : (
              <div className='empty-booking md:mt-12'>
                <h1>{t.no_upcoming_bookings}</h1>
                <h2>{t.want_to_create}</h2>
                <button className="btn max-md:w-auto max-md:mb-2"><Link to="/book">{t.book_a_room}</Link></button>
              </div>
            )}
          </div>
        </div>
      </main>

      <Overlay
        title={(new Date(selectedBooking.endTime) > new Date()) ? t.manage_booking : 'Booking details'}
        isOpen={showOverlay} 
        onClose={closeOverlay}
        room={selectedBooking.Room}
        inputBooking={getSelectedBookingWithCost()}
        editable={(new Date(selectedBooking.endTime) > new Date())}
        newBooking={false}
      />
    </>
  );
};

export default Home;
